import React from "react";
import { classNames } from "utils/utils";
import { useGame } from "context/gameContext";
import { useModalContext } from "context/modalContext";
import {
  SCORES_1ST_HALF,
  SCORES_2ND_HALF,
  SCORES_ET,
  SCORES_PENALTY_SHOOTOUT,
  SCORES_ET_2ND_HALF,
  SCORES_CURRENT,
  NOT_STARTED,
  FIRST_HALF,
  FULL_TIME,
  IN_PLAY_IN_2ND_HALF,
  HALF_TIME,
} from "utils/constants";

import EventTimeStatus from "components/eventTime";

const EventInfo = ({ event, showLogos, gameRule, prediction }) => {
  const { openModal } = useModalContext();

  const {
    state: { theme },
    dispatch: gameDispatch,
  } = useGame();

  const handleOpenModal = () => {
    openModal(event);
  };

  const eventStatusClassNames = [];
  let eventState = event?.state_id;
  if (eventState === FULL_TIME || event?.settled) {
    eventStatusClassNames.push("bg-gray-200");
  } else if (
    eventState === FIRST_HALF ||
    eventState === HALF_TIME ||
    eventState === IN_PLAY_IN_2ND_HALF
  ) {
    //include all live states
    eventStatusClassNames.push("bg-customGreen text-black");
  } else {
    eventStatusClassNames.push("");
  }
  const eventStatusClassNamesResult = eventStatusClassNames.join(" ");

  const scorePeriod = prediction ? SCORES_CURRENT : SCORES_CURRENT;

  const homeTeamScore = event?.scores?.find(
    (x) =>
      x.type_id === scorePeriod && x.participant_id === event?.teams?.home?.id
  )?.score?.goals;
  const awayTeamScore = event?.scores?.find(
    (x) =>
      x.type_id === scorePeriod && x.participant_id === event?.teams?.away?.id
  )?.score?.goals;

  let isCorrectScore = gameRule == 1 || gameRule == 3;
  let eventStarted = event?.startTime?.seconds * 1000 < new Date();

  let spacing = isCorrectScore ? "space-y-1" : "space-y-0.5";
  return (
    <>
      <div
        key={event?.eventId}
        onClick={handleOpenModal}
        className={classNames(
          event?.settled || theme?.id === 0 ? "" : "shadow-md",
          prediction ? "rounded-l-md" : "rounded-md",
          "flex bg-white  px-2 py-2  w-full text-sm"
        )}
      >
        <div
          className={classNames(
            "flex justify-between w-full h-full items-center",
            gameRule == 2 ? "flex-row-reverse" : ""
          )}
        >
          <div
            className={classNames(
              isCorrectScore ? "h-full items-center" : "h-fit",
              "flex w-full"
            )}
          >
            <div
              className={classNames(
                eventStatusClassNamesResult,
                isCorrectScore ? "h-full justify-center space-y-1" : "h-fit",
                isCorrectScore && !eventStarted ? "hidden" : "flex",
                " flex-col rounded-md p-1 px-2  text-center mr-2 w-6"
              )}
            >
              <div className="w-full">
                {homeTeamScore !== undefined ? homeTeamScore : "-"}
              </div>
              <div className="w-full">
                {awayTeamScore !== undefined ? awayTeamScore : "-"}
              </div>
            </div>

            {showLogos ? (
              <div
                className={classNames("flex flex-col  justify-center", spacing)}
              >
                <div className="flex justify-center items-center mr-2 w-4 h-5 rounded-sm">
                  {/* <img className="" src={homeTeam?.logo} /> */}
                </div>
                <div className="flex justify-center items-center mr-2 w-4 h-5 rounded-sm">
                  {/* <img className="" src={awayTeam?.logo} /> */}
                </div>
              </div>
            ) : (
              <></>
            )}
            <div
              className={classNames(
                "flex flex-col w-full justify-center font-normal",
                isCorrectScore && !eventStarted ? "pl-1" : "",
                spacing
              )}
            >
              <div className=" w-full grid grid-flow-col ">
                <span className="truncate ">{event?.teams?.home?.name}</span>
              </div>
              <div className=" w-full grid grid-flow-col ">
                <span className="truncate ">{event?.teams?.away?.name}</span>
              </div>
            </div>
            {/* {!event?.settled && gameRule != 1 && gameRule != 3 && ( */}
            {!event?.settled && (
              <EventTimeStatus
                startTime={
                  event?.startTime?._seconds
                    ? event?.startTime?._seconds
                    : event?.startTime?.seconds
                }
                eventState={event?.state_id}
                eventPeriods={event?.periods}
                vertical={true}
                gameRule={gameRule}
                lastUpdatedAt={event?.statsUpdatedAt?.seconds}
                prediction={prediction}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EventInfo;
